var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showCarousel,
              expression: "!showCarousel",
            },
          ],
          staticClass: "kc-archive-cats-resources__cat__items normal",
        },
        _vm._l(_vm.printPost, function (post) {
          return _c(
            "a",
            {
              key: `kc-archive-cats-resources__item-${post.id}`,
              staticClass: "swiper-slide kc-archive-cats-resources__item",
              attrs: { href: post.link },
            },
            [
              _c(
                "div",
                { staticClass: "kc-archive-cats-resources__item__img" },
                [_c("imageSrcset", { attrs: { imageVar: post.image } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "kc-archive-cats-resources__item__content" },
                [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "kc-archive-cats-resources__item__content__title",
                    },
                    [_vm._v(_vm._s(post.title))]
                  ),
                  _vm._v(" "),
                  post.read_time
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "kc-archive-cats-resources__item__content__read-time",
                        },
                        [
                          _c("svg", { attrs: { viewBox: "0 0 512 512" } }, [
                            _c("path", {
                              attrs: {
                                d: "M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(post.read_time) + " min read"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showCarousel
        ? _c(
            "swiper",
            {
              ref: "resourcesCarousel",
              staticClass: "kc-archive-cats-resources__cat__items carousel",
              attrs: { options: _vm.swiperOptions },
            },
            _vm._l(_vm.carouselSlides, function (slide, i) {
              return _c(
                "swiper-slide",
                {
                  key: `kc-archive-cats-resources__slide-${i}`,
                  staticClass: "auto-columns",
                },
                _vm._l(slide, function (post) {
                  return _c(
                    "a",
                    {
                      key: `kc-archive-cats-resources__slide-item-${post.link}`,
                      staticClass:
                        "swiper-slide kc-archive-cats-resources__item",
                      attrs: { href: post.link },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "kc-archive-cats-resources__item__img" },
                        [
                          _c("imageSrcset", {
                            attrs: { imageVar: post.image },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "kc-archive-cats-resources__item__content",
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "kc-archive-cats-resources__item__content__title",
                            },
                            [_vm._v(_vm._s(post.title))]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "kc-archive-cats-resources__item__content__excerpt",
                            domProps: { innerHTML: _vm._s(post.excerpt) },
                          }),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.posts.length > _vm.curPostPerPage,
              expression: "posts.length > curPostPerPage",
            },
          ],
          staticClass: "kc-archive-cats-resources__button btn btn--blue",
          on: { click: _vm.showMore },
        },
        [_vm._v("See all Resources")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }